var exports = {
  "kL": "x31de4314--c58770--container",
  "Qs": "x31de4314--c58770--content",
  "DD": "x31de4314--c58770--title",
};

module.exports = exports;
